import React from "react";
import ReactDOM from "react-dom";

export default function SelectLike({
  options,
  value,
  onChange,
  maxVisible = 10,
  placeholder = "انتخاب کنید",
  className = "",
  dir = "rtl",
}) {
  const [open, setOpen] = React.useState(false);
  const [activeIndex, setActiveIndex] = React.useState(
    Math.max(0, options.findIndex((o) => o.id === value))
  );

  const rootRef = React.useRef(null);   // ریشه (حاوی دکمه)
  const btnRef = React.useRef(null);    // خود دکمه
  const menuRef = React.useRef(null);   // منو در پورتال

  const selected = options.find((o) => o.id === value);
  const itemHeight = 36;
  const maxHeight = Math.min(options.length, maxVisible) * itemHeight;

  // محاسبه موقعیت منو (fixed نسبت به viewport)
  const [pos, setPos] = React.useState({ top: 0, left: 0, width: 0 });
  const updatePosition = React.useCallback(() => {
    const el = btnRef.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    setPos({ top: r.bottom + 4, left: r.left, width: r.width });
  }, []);
  React.useEffect(() => {
    if (!open) return;
    updatePosition();
    const onScrollOrResize = () => updatePosition();
    // فقط اسکرول و ریسایز window؛ نه capture
    window.addEventListener("scroll", onScrollOrResize);
    window.addEventListener("resize", onScrollOrResize);
    return () => {
      window.removeEventListener("scroll", onScrollOrResize);
      window.removeEventListener("resize", onScrollOrResize);
    };
  }, [open, updatePosition]);

  // بستن با کلیک بیرون (روی click نه mousedown)
  React.useEffect(() => {
    if (!open) return;
    function onDocClick(e) {
      const target = e.target;
      const insideButton = btnRef.current && btnRef.current.contains(target);
      const insideMenu = menuRef.current && menuRef.current.contains(target);
      if (!insideButton && !insideMenu) setOpen(false);
    }
    document.addEventListener("click", onDocClick);
    return () => document.removeEventListener("click", onDocClick);
  }, [open]);

  // کیبورد
  function onKeyDown(e) {
    if (!open) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        setOpen(true);
        setTimeout(updatePosition, 0);
      }
      return;
    }
    if (e.key === "Escape") {
      e.preventDefault();
      setOpen(false);
      return;
    }
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setActiveIndex((i) => Math.min(options.length - 1, i + 1));
    }
    if (e.key === "ArrowUp") {
      e.preventDefault();
      setActiveIndex((i) => Math.max(0, i - 1));
    }
    if (e.key === "Enter") {
      e.preventDefault();
      const opt = options[activeIndex];
      if (opt) {
        onChange(opt.id);
        setOpen(false);
      }
    }
  }

  return (
    <div className={`relative ${className}`} ref={rootRef} dir={dir}>
      <button
        ref={btnRef}
        type="button"
        aria-haspopup="listbox"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
        onKeyDown={onKeyDown}
        className="w-64 border border-gray-300 rounded px-2 py-1 text-sm text-right bg-white focus:outline-none flex items-center justify-between"
      >
        <span className="truncate">{selected ? selected.name : placeholder}</span>
        <svg width="18" height="18" viewBox="0 0 24 24" className="shrink-0">
          <path d="M7 10l5 5 5-5" fill="none" stroke="currentColor" strokeWidth="2" />
        </svg>
      </button>

      {open &&
        ReactDOM.createPortal(
          <div
            ref={menuRef}
            role="listbox"
            tabIndex={-1}
            style={{
              position: "fixed",
              top: pos.top,
              left: pos.left,
              width: pos.width,
              zIndex: 100000,
              maxHeight,
              overflowY: options.length > maxVisible ? "auto" : "visible",
              direction: dir,
              // جلوگیری از حباب اسکرول به والدها
              overscrollBehavior: "contain",
            }}
            className="border border-gray-200 bg-white rounded shadow"
            onKeyDown={onKeyDown}
          >
            {options.map((opt, idx) => {
              const isSelected = opt.id === value;
              const active = idx === activeIndex;
              return (
                <div
                  key={opt.id}
                  role="option"
                  aria-selected={isSelected}
                  className={`px-3 py-2 text-sm text-right cursor-pointer ${
                    active ? "bg-gray-100" : ""
                  } ${isSelected ? "font-medium" : ""}`}
                  onMouseEnter={() => setActiveIndex(idx)}
                  onClick={() => {
                    onChange(opt.id);
                    setOpen(false);
                  }}
                >
                  {opt.name}
                </div>
              );
            })}
          </div>,
          document.body
        )}
    </div>
  );
}
